import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog } from '@totalsoft/rocket-ui';
import ReactJson from '@microlink/react-json-view';
import { useTranslation } from 'react-i18next';

const EditJsonContentDialog = props => {
  const { open, content, onChange, onClose, onCancel, onConfirm, customHeaderComponent, onReloadJson } = props;
  const { t } = useTranslation();

  return (
    <Dialog
      id='edit-json-dialog'
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={'sm'}
      title={t('JsonFileContent.EditJsonTitle')}
      content={
        <>
          {customHeaderComponent}
          <ReactJson
            id='themeJson'
            name={'theme'}
            src={content}
            theme='shapeshifter:inverted'
            indentWidth={2}
            onEdit={onChange}
            onAdd={onChange}
            onDelete={onChange}
            enableClipboard={true}
          />
        </>
      }
      actions={
        <>
          <Button id='btnJsConfirm' onClick={onConfirm}>
            {t('JsonFileContent.Confirm')}
          </Button>
          <Button id='btnJsCancel' onClick={onCancel}>
            {t('JsonFileContent.Cancel')}
          </Button>
          {onReloadJson && (
            <Button id='btnJsReload' onClick={onReloadJson}>
              {t('JsonFileContent.Reload')}
            </Button>
          )}
        </>
      }
    />
  );
};

EditJsonContentDialog.propTypes = {
  open: PropTypes.bool,
  content: PropTypes.object,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  inputProps: PropTypes.object,
  customHeaderComponent: PropTypes.node,
  onReloadJson: PropTypes.func
};

export default EditJsonContentDialog;
